module.exports = __webpack_public_path__ + "img/frame.3d0fa528.svg";